import { render, staticRenderFns } from "./ModalCompleteTemuan.vue?vue&type=template&id=1dada487&scoped=true&"
import script from "./ModalCompleteTemuan.vue?vue&type=script&lang=js&"
export * from "./ModalCompleteTemuan.vue?vue&type=script&lang=js&"
import style0 from "./ModalCompleteTemuan.vue?vue&type=style&index=0&id=1dada487&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dada487",
  null
  
)

export default component.exports